import { confirm } from '@app/components/Modal/confirmModal';

export function showNeedToSelectAtleastOneModal(translation: Function) {
    confirm(translation('SELECT_MORE'),
        translation('OK'),
        undefined,
        '').then(
            () => {
                // do nothing
            },
            () => {
                // do nothing on cancel
            }
        );
}
